import axios from "axios";
import { logout } from "../utils/auth"; 

// Tenta pegar a URL do ambiente, senão usa localhost
export const API_BASE_URL = window.env?.REACT_APP_API || process.env.REACT_APP_API || 'http://localhost:4000/api';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// REQUEST INTERCEPTOR: Anexa o token em toda requisição
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// RESPONSE INTERCEPTOR: O "Xerife" da segurança
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    
    // Se recebermos 401 (Não autorizado) ou 403 (Proibido)
    // Significa que o token é inválido, expirou ou foi manipulado.
    if (status === 401 || status === 403) {
        const path = window.location.pathname;

        // Evita loop infinito se já estivermos na tela de login
        if (!path.includes('/login') && !path.includes('/painelsessao') && !path.includes('/obs')) {
            console.warn(`⛔ Acesso negado em ${path}. Token inválido ou manipulado.`);
            
            // 1. Limpeza total imediata
            localStorage.clear(); 
            // Nota: logout() do utils/auth também faz clear, mas reforçamos aqui.
            logout(); 

            // 2. Redirecionamento forçado via window.location (mais seguro que navigate aqui)
            // Se for rota de painel, recarrega para tentar reconectar ou mostrar erro
            if (path.includes('/painel') || path.includes('/obs')) {
                 window.location.reload();
            } else {
                 window.location.href = "/login?expired=true";
            }
        }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;